enum CheckType {
  NEW_PROJECT = 'new_project',
  NEW_BOARD = 'new_board',
  POINTS_FIELD_CHANGED = 'points_field_changed',
  FALSE_POSITIVE_DELETION = 'false_positive_deletion',
  BOARD_NOT_FOUND = 'board_not_found',
}

type IntegrationHealthCheck = {
  id: string;
  system_access: string;
  organization: string;
  check_type: CheckType;
  status: 'active' | 'resolved' | 'dismissed';
  external_identifier: string;
  details: Record<string, unknown>;
  resolution_url: string;
  dismissed_by: string | null;
  dismissed_at: string | null;
  resolved_at: string | null;
  last_detected_at: string;
  metadata_created_at: string;
  metadata_updated_at: string;
};

type HealthCheckCounts = Record<string, number>;

export { CheckType };
export type { HealthCheckCounts, IntegrationHealthCheck };
